import React from 'react';
import { Button } from 'react-bootstrap';

type Props = {
  label: string;
  showButton: boolean;
  btnLabel: string;
  onBtnClick: () => void;
};

const RedirectToast = ({ label, showButton, btnLabel, onBtnClick }: Props) => {
  return (
    <div className='d-flex justify-content-between'>
      <div>{label}</div>
      {showButton && (
        <Button
          onClick={onBtnClick}
          variant='outline-secondary'
          size='sm'
          bsPrefix='btn-toast'
        >
          {btnLabel}
        </Button>
      )}
    </div>
  );
};

export default RedirectToast;
